<!-- =========================================================================================
  File Name: Users.vue
  Description: User list
  ----------------------------------------------------------------------------------------
  Item Name: C4 - User list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div>
    <div class="flex mb-base">
      <div v-for="item in cashRegisters" :key="item.id" class="w-full md:w-1/3 lg:w1/4 m-2">
        <vx-card>
          <h5 class="mb-2">{{ item.name }}</h5>
          <p class="text-grey">{{ item.sessionStatusName }}</p>

          <div class="flex justify-between flex-wrap" v-if="item.resolutionId1 > 0">
            <p><b>{{ item.resolutionName1 }}</b></p>
            <p>Número final: {{ item.finalNumber1}}</p>
            <p class="mb-2">Número actual: {{ item.currentNumber1}}</p>
          </div>
          <div class="flex justify-center flex-wrap" v-if="item.resolutionId1 > 0">
            <vs-chip :color="getChipColor(item.remaining1)">
              <span v-if="item.remaining1 < 1000" style="width: 36px; height: 36px; background-color: white; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center; border-radius: 18px;"><h6><b>{{ item.remaining1 }}</b></h6></span>
              <span v-else style="width: 36px; height: 36px; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center;"><h6><b>{{ item.remaining1 }}</b></h6></span>
              <b>Documentos restantes en resolución</b>
            </vs-chip>
            <vs-divider/>
          </div>

          <div class="flex justify-between flex-wrap" v-if="item.resolutionId2 > 0">
            <p><b>{{ item.resolutionName2 }}</b></p>
            <p>Número final: {{ item.finalNumber2}}</p>
            <p class="mb-2">Número actual: {{ item.currentNumber2}}</p>
          </div>
          <div class="flex justify-center flex-wrap" v-if="item.resolutionId2 > 0">
            <vs-chip :color="getChipColor(item.remaining2)">
              <span v-if="item.remaining2 < 1000" style="width: 36px; height: 36px; background-color: white; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center; border-radius: 18px;"><h6><b>{{ item.remaining2 }}</b></h6></span>
              <span v-else style="width: 36px; height: 36px; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center;"><h6><b>{{ item.remaining2 }}</b></h6></span>
              <b>Documentos restantes en resolución</b>
            </vs-chip>
            <vs-divider/>
          </div>

          <div class="flex justify-between flex-wrap" v-if="item.resolutionId3 > 0">
            <p><b>{{ item.resolutionName3 }}</b></p>
            <p>Número final: {{ item.finalNumber3}}</p>
            <p class="mb-2">Número actual: {{ item.currentNumber3}}</p>
          </div>
          <div class="flex justify-center flex-wrap" v-if="item.resolutionId3 > 0">
            <vs-chip :color="getChipColor(item.remaining3)">
              <span v-if="item.remaining3 < 1000" style="width: 36px; height: 36px; background-color: white; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center; border-radius: 18px;"><h6><b>{{ item.remaining3 }}</b></h6></span>
              <span v-else style="width: 36px; height: 36px; margin: 5px 5px 5px 0px; display: inline-grid; align-items: center; text-align: center;"><h6><b>{{ item.remaining3 }}</b></h6></span>
              <b>Documentos restantes en resolución</b>
            </vs-chip>
            <vs-divider/>
          </div>

          <div class="flex justify-between flex-wrap" v-if="item.sessionStatusId == 'A'">

          </div>

          <div class="flex justify-between flex-wrap">
            <vs-button v-if="item.sessionStatusId == 'C'" class="mt-4 mr-2 shadow-lg" type="gradient" color="success" gradient-color-secondary="success" @click="newSession(item)">Abrir caja</vs-button>
            <vs-button v-if="item.sessionStatusId == 'A'" class="mt-4 mr-2 shadow-lg" type="gradient" color="success" gradient-color-secondary="success" @click="resumeSession(item)">Reanudar sesión</vs-button>
            <vs-button v-if="item.sessionStatusId == 'C'" class="mt-4" type="border" color="success" @click="showSession(item)">Ver último cierre</vs-button>
            <vs-button v-if="item.sessionStatusId == 'A'" class="mt-4" type="border" color="danger" @click="closeSession(item)">Cerrar caja</vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config');
  export default {
    data() {
      return {
        cashRegisters: [],
        viewID: 0,
        data: []
      }
    },
    // provide: {
    //   grid: [Toolbar, Search, Page, Sort, ExcelExport, Aggregate]
    // },
    methods: {
      getChipColor(value) {
        var color = 'success';
        if (value < 200 && value > 50) {
          color = 'warning';
        } else if (value < 50) {
          color = 'danger';
        }
        return color;
      },
      getCachRegisters() {
        this.$vs.loading({
          text: 'Cargando cajas',
          type: 'point'
        });
        var self = this;
        var data = {
          statusId: 'ACT',
          context: this.$store.state.AppActiveUser
        };
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/cash_register/list_session', data).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              self.cashRegisters = response.data.data;
            }
          }
          this.$vs.loading.close();
          self.loaded = true;
        }).catch(error => {
          self.loaded = true;
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.response) {
            errorMessage = error.response.data.ErrorMessage
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar listado de cajas',
            text: errorMessage,
            color: 'danger'
          });
        })
      },
      resumeSession(cashRegister) {
        // if (cashRegister.remaining > 0) {
          localStorage.setItem(`${deltaPOS_config.default.itemPrefix}CashSessionId`, cashRegister.sessionId);
          this.$router.push({name: 'takeOrder'});
        // } else {
        //   this.$vs.notify({
        //     title: 'Error al reanudar sesión de caja',
        //     text: `No hay correlativos disponibles para la resolución de caja ${cashRegister.resolutionName}`,
        //     color: 'danger'
        //   });
        // }
      },
      newSession(cashRegister) {
        this.$vs.loading({
          text: 'Abriendo sesión de caja',
          type: 'point'
        });
        var self = this;
        var data = {
          cashRegisterId: cashRegister.id,
          context: this.$store.state.AppActiveUser
        };
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/cash_register/new_session', data).then(response => {
          self.$vs.loading.close();
          if (response.data.success) {
            if (response.data.data) {
              if (response.data.data.id > 0) {
                localStorage.setItem(`${deltaPOS_config.default.itemPrefix}CashSessionId`, response.data.data.id);
                self.$router.push({name: 'takeOrder'});
              } else {
                self.$vs.notify({
                  title: 'Error al abrir sesión de caja',
                  text: response.data.message,
                  color: 'danger'
                });
              }
            }
          }
        }).catch(error => {
          self.loaded = true;
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.response) {
            errorMessage = error.response.data.ErrorMessage
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al abrir sesión de caja',
            text: errorMessage,
            color: 'danger'
          });
        })
      },
      closeSession(cashRegister) {
        if (cashRegister.sessionStatusId == 'A') {
          this.$router.push({name: 'session', params: {id: cashRegister.sessionId}});
        } else {
          this.$vs.notify({
            title: 'Error al cerrar sesión de caja',
            text: 'La sesión de caja no está abierta',
            color: 'danger'
          });
        }
      },
      showSession(cashRegister) {
        this.$router.push({name: 'session', params: {id: cashRegister.sessionId}});
      }
    },
    mounted() {
      this.getCachRegisters();
    }
  }
</script>

<style lang="scss">
  @import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
  /*@import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css';*/
  /*@import '../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  /*@import '../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';*/
  @import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
